import {JsonApiModel, JsonApiModelConfig, Attribute} from "angular2-jsonapi";
/**
 * Created by markush on 3/11/17.
 */

@JsonApiModelConfig({
  type: 'customer_category'
})
export class CustomerCategory extends JsonApiModel {

  @Attribute()
  name: string;

  @Attribute()
  color: string;

  public get letter() {
    return this.name.substr(0, 1);
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/models/customer-category.ts